module.exports = __webpack_public_path__ + "static/media/srm-icon.32e61742.png";